var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-q relative"},[(_vm.mapPattern)?[_c('map-pattern',{attrs:{"issue":_vm.issue}})]:(_vm.textPattern)?[_c('text-map',{attrs:{"issue":_vm.issue}})]:_vm._e(),(_vm.view)?_c('div',{staticClass:"absolute inset-0 z-10"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }